import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { chineseCrmMessagesFlat } from "./chineseCrmMessages";
import { chineseRaMessagesFlat, unflattenMessages } from "./chineseRaMessages";
import { chineseEgiMessagesFlat, englishEgiMessagesFlat } from "./egiMessages";
import { englishCrmMessages } from "./englishCrmMessages";

const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Ask your admin for a login link to reset your password.",
    },
    oauth: {
      authorize: "Authorize Application",
      authorize_details: "This application wants to access your account.",
      access_scope:
        "It will be able to read and modify your data, with the same permissions as your account.",
      approved: "Authorization Approved",
      close_tab: "You can now close this tab.",
      no_request: "No authorization request found",
    },
  },
};

const englishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  raSupabaseEnglishMessagesOverride,
  englishCrmMessages,
  unflattenMessages(englishEgiMessagesFlat),
);

// Chinese falls back to English for any key it does not translate.
const chineseCatalog = mergeTranslations(
  englishCatalog,
  unflattenMessages(chineseRaMessagesFlat),
  unflattenMessages(chineseCrmMessagesFlat),
  unflattenMessages(chineseEgiMessagesFlat),
);

export const getInitialLocale = (): "en" | "zh" => {
  if (typeof navigator === "undefined") {
    return "en";
  }

  const browserLocale = navigator.languages?.[0] ?? navigator.language;
  if (browserLocale?.toLowerCase().startsWith("zh")) {
    return "zh";
  }

  return "en";
};

export const i18nProvider = polyglotI18nProvider(
  (locale) => {
    if (locale === "zh") {
      return chineseCatalog;
    }
    return englishCatalog;
  },
  getInitialLocale(),
  [
    { locale: "en", name: "English" },
    { locale: "zh", name: "中文" },
  ],
  { allowMissing: true },
);

export const testI18nProvider = polyglotI18nProvider(
  () => englishCatalog,
  "en",
  [{ locale: "en", name: "English" }],
  { allowMissing: true },
);
